import { Card } from '@/features/Cards/cards.types'
import { formatUsdAmount } from '@/shared/helpers/currency'

export const CardsMapper = {
  filterCardsByAccount: (cards: Card[], account: string, accountType: 'solana' | 'spl') => {
    if (!cards?.length || !account) return null
    return cards?.filter((card) => (accountType === 'solana' ? card.solanaAddress === account : card.tokenAddress === account))
  },

  cardsSpendableSum: (cards: Card[], account: string) => {
    if (!cards?.length) return formatUsdAmount('0')
    const total = cards.reduce((sum, card) => (card.solanaAddress === account ? sum + Number(card.balance.amount) : sum), 0)
    return formatUsdAmount(total.toString())
  },

  sortByMainWallet: (cards: Card[], mainWalletAddress?: string): Card[] => {
    if (!mainWalletAddress) return cards

    return [...cards].sort((a, b) => {
      const aIsMain = a.solanaAddress === mainWalletAddress
      const bIsMain = b.solanaAddress === mainWalletAddress
      if (aIsMain === bIsMain) return 0
      return aIsMain ? -1 : 1
    })
  },
}
